var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBlueUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.306 6.829A1 1 0 006.72 5.414L2.478 1.172a1 1 0 00-1.415 1.414L5.306 6.83z",
    fill: "#005FF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.694 6.829A1 1 0 015.28 5.414l4.243-4.242a1 1 0 011.414 1.414L6.694 6.83z",
    fill: "#005FF9"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS4zMDYgNi44MjlBMSAxIDAgMDA2LjcyIDUuNDE0TDIuNDc4IDEuMTcyYTEgMSAwIDAwLTEuNDE1IDEuNDE0TDUuMzA2IDYuODN6IiBmaWxsPSIjMDA1RkY5Ii8+PHBhdGggZD0iTTYuNjk0IDYuODI5QTEgMSAwIDAxNS4yOCA1LjQxNGw0LjI0My00LjI0MmExIDEgMCAwMTEuNDE0IDEuNDE0TDYuNjk0IDYuODN6IiBmaWxsPSIjMDA1RkY5Ii8+PC9zdmc+";
export { SvgArrowBlueUp as ReactComponent };